export default function (
    $sbProjectApi,
    $sbCurrentProject,
    $sbCalendarRepository
) {
    "ngInject";

    return {
        getCurrent: $sbCurrentProject.get,
        getCalendar: _getCalendar,
        getCurrentProjectId: $sbCurrentProject.pick.bind(this, "id"),
        refreshCurrent: _refreshCurrent,
    };

    function _refreshCurrent() {
        return $sbProjectApi.refresh($sbCurrentProject.pick("id"));
    }

    function _getCalendar(projectId) {
        return $sbCalendarRepository.get(
            projectId || $sbCurrentProject.pick("id")
        );
    }
}
